var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"link",class:{
    'arrow-down': _vm.arrowDown,
    'arrow-up': !_vm.arrowDown,
    'red': _vm.theme === 'red',
    'blue': _vm.theme === 'blue',
    'green': _vm.theme === 'green',
  },attrs:{"to":_vm.linkTo}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}}),_c('img',{attrs:{"src":require(("@/assets/image/pointer-" + _vm.theme + ".png")),"alt":"","draggable":"false"}})])}
var staticRenderFns = []

export { render, staticRenderFns }